import { Center, Flex, Image, useToast, Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LighthouseAnimation } from "../../components/shared/animations/LighthouseAnimation";
import { errorToast } from "../../constants/toast.constants";
import { IdentityService } from "../../service/identity.service";
import { MagiclinkService } from "../../service/third-party/magiclink.service";
import { TokenService } from "../../service/token.service";
import { update } from "../../store/slice/Account/user-profile.slice";
import { updateSidebar } from "../../store/slice/Sidebar/sidebar.slice";
import { tokenSlice } from "../../store/slice/Token/token.slice";
import { getQueryParam } from "../../utils/url.util";
import { colors } from "../../constants/design.constants";

export const LoginRedirect: React.FC<any> = () => {
  const identityService = new IdentityService();

  const { email, password } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast();

  const identityLogin = async (token: string | null) => {
    if (!email) navigate("/unauthorized");

    if (!token) {
      toast(errorToast("Failed token authentication. Please try again", 7500));
      navigate("/auth/login");
    }

    await identityService
      .magicLinklogin(email!, token!, password)
      .then(async (token: any) => {
        dispatch(
          tokenSlice.actions.update({ accessToken: token.accessToken } as any)
        );

        dispatch(updateSidebar({ logoSrc: "", workflows: [] }));
        dispatch(update({ email: email }));

        navigate("/dashboard");
      })
      .catch(() => {
        navigate("/unauthorized");
      });
  };

  const finishEmailRedirectLogin = async () => {
    const didToken = getQueryParam("did_token");
    await identityLogin(didToken);
  };

  useEffect(() => {
    finishEmailRedirectLogin();
  }, []);

  return (
    <Box
      bg={colors.void}
      h="100vh"
      position="relative"
      overflow="hidden"
      backgroundImage={`
        radial-gradient(ellipse 60% 40% at 50% 30%, rgba(94, 184, 212, 0.08), transparent),
        linear-gradient(${colors.borderSubtle} 1px, transparent 1px),
        linear-gradient(90deg, ${colors.borderSubtle} 1px, transparent 1px)
      `}
      backgroundSize="100% 100%, 48px 48px, 48px 48px"
    >
      <Flex mt="28vh" flexDirection="column" color="white" position="relative" zIndex={1}>
        <Center>
          <Image
            src="/assets/sidebar/slu-branding.svg"
            alt="Sumlookup Branding"
            width="220px"
            mb={4}
            filter="brightness(1.1)"
            opacity={0.9}
          />
        </Center>

        <Center mb="16px">
          <Text
            fontSize="11px"
            fontWeight="500"
            letterSpacing="0.18em"
            textTransform="uppercase"
            color={colors.signal}
          >
            Establishing session
          </Text>
        </Center>

        <Center>
          <LighthouseAnimation />
        </Center>
      </Flex>
    </Box>
  );
};
